__turbopack_context__.v({
  "group": "sidebar-layout-module-scss-module__j7B3zG__group",
  "inset": "sidebar-layout-module-scss-module__j7B3zG__inset",
  "menu": "sidebar-layout-module-scss-module__j7B3zG__menu",
  "menuButton": "sidebar-layout-module-scss-module__j7B3zG__menuButton",
  "menuButtonClosing": "sidebar-layout-module-scss-module__j7B3zG__menuButtonClosing",
  "menuButtonCollapsed": "sidebar-layout-module-scss-module__j7B3zG__menuButtonCollapsed",
  "menuItem": "sidebar-layout-module-scss-module__j7B3zG__menuItem",
  "mobileHeaderSpacer": "sidebar-layout-module-scss-module__j7B3zG__mobileHeaderSpacer",
});
